import { t } from 'i18next';

export enum OperationCategory {
  ASYMMETRIC_KEY_GENERATION = 'asymmetric_key_generation',
  SYMMETRIC_KEY_GENERATION = 'symmetric_key_generation',
  ENCRYPTION_DECRYPTION = 'encryption_decryption',
  SIGNATURE = 'signature_generation_verification',
  MAC = 'mac',
  HASHING = 'hashing',
  KEY_WRAPPING_UNWRAPPING = 'key_wrapping_unwrapping',
  KEY_DERIVATION = 'key_derivation',
  KEYSTORE_ACCESS = 'key_store_access',
  KEYSTORE_LOADING = 'key_store_creation_loading',
  KEY_AGREEMENT = 'key_agreement',
  CLOUD_STORAGE = 'cloud_storage',
  KEY_DEFINITION = 'key_definition',
  TLS_INITIALIZATION = 'tls_initialization',
  TLS_HANDSHAKE = 'tls_handshake',
  SSH_HANDSHAKE = 'ssh_handshake',
}

export const getOperationCategoryLabel = (category: OperationCategory): string => {
  return t(`operationProperties.categories.${category}`);
};
